import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  createTheme,
  Grid,
  TextField,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import StarIcon from '@mui/icons-material/Star';

const greenTheme = createTheme({
  palette: {
    primary: {
      main: "#4CAF50",
    },
  },
});

const DoctorRating = () => {
  const [communication, setCommunication] = useState(3);
  const [satisfaction, setSatisfaction] = useState(0);
  const [recommendation, setRecommendation] = useState(null);
  const [review, setReview] = useState("");

  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));

  const renderStars = (value, setValue) => (
    <Box>
      {[1, 2, 3, 4, 5].map((i) => (
        <StarIcon
          key={i}
          onClick={() => setValue(i)}
          sx={{
            color: i <= value ? "#FFD700" : "#ccc",
            cursor: "pointer",
            fontSize: 30,
          }}
        />
      ))}
    </Box>
  );

  return (
    <ThemeProvider theme={greenTheme}>
      <Box sx={{ maxWidth: 700, mx: "auto", p: isMobile ? 2 : 4 }}>
        <Button variant="text" sx={{ mb: 2 }}>← Doctor's Rating</Button>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              How well did the doctor listen to your concerns and explain things in a clear, understandable way?
            </Typography>
            {renderStars(communication, setCommunication)}

            <Typography variant="h6" mt={3} gutterBottom>
              How satisfied are you with the care and treatment provided during your visit?
            </Typography>
            {renderStars(satisfaction, setSatisfaction)}

            <Typography variant="h6" mt={3} gutterBottom>
              How likely are you to recommend this doctor to family or friends?
            </Typography>
            <Grid container spacing={1}>
              {[1, 2, 3, 4, 5].map((num) => (
                <Grid item key={num}>
                  <Button
                    variant={recommendation === num ? "contained" : "outlined"}
                    onClick={() => setRecommendation(num)}
                    sx={{ minWidth: 40 }}
                  >
                    {num}
                  </Button>
                </Grid>
              ))}
            </Grid>
            <Typography variant="body2" mt={1} color="textSecondary">
              (Rating: 1 - Not likely at all, 5 - Extremely likely)
            </Typography>

            <Box mt={3}>
              <Typography variant="h6" gutterBottom>
                Tell us more about his service
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={4}
                placeholder="Write your review"
                value={review}
                onChange={(e) => setReview(e.target.value)}
              />
            </Box>

            <Button
              variant="contained"
              fullWidth
              sx={{ mt: 3 }}
            >
              Submit Review
            </Button>
          </CardContent>
        </Card>
      </Box>
    </ThemeProvider>
  );
};

export default DoctorRating;
